import { Component, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import * as _ from 'lodash';
import { CommonMethod } from 'src/app-core/methods/common-methods';
import { CommonService } from 'src/app-core/services/common.service';
import { QuotesDataModel } from 'src/app/quotes/quotes-data-model';

@Component({
    selector: 'app-retain-modifiers-dialog',
    templateUrl: './retain-modifiers-dialog.component.html',
    styleUrls: ['./retain-modifiers-dialog.component.scss']
})
export class RetainModifiersDialogComponent implements OnInit {

    @ViewChild('retainModifiersForm', { static: false }) retainModifiersForm: NgForm;
    @Output() retainModifiersPayloadEmitter = new EventEmitter<any>();
    quotesDataModel = new QuotesDataModel();
    retainModifiersPayload = _.cloneDeep(this.quotesDataModel.retainModifiersPayload);
    isFormLoading: false;
    newData: any = null;
    orderId: any;
    retainCategories: any[] = [];
    initialRetainCategories: any[] = [];
    categoryDisplayNames = {
        'pallet': 'Pallet',
        'bottomDeckBoard': 'Bottom Deck Board',
        'floater': 'Floater',
        'fullPerpRubStrips': 'Full Perpendicular Rub Strips',
        'gussets': 'Gussets'
    };

    constructor(
        private dialogRef: MatDialogRef<RetainModifiersDialogComponent>,
        private commonService: CommonService,
        private commonMethod: CommonMethod,
        @Inject(MAT_DIALOG_DATA) data?: any) {
        if (data) {
            this.retainModifiersPayload.itemContainerId = data.containerId;
        }
    }

    ngOnInit() {
        this.commonMethod.getOrderId.subscribe(data => {
            this.orderId = data;
            this.onLoadItems();
        });
    }

    onLoadItems() {
        this.getRetainCategories();
    }

    getRetainCategories(): void {
        this.commonService.getRetainCategoriesList(this.orderId, this.retainModifiersPayload.itemContainerId).subscribe((response: any) => {
            this.retainCategories = response.data[0].retainCategories;
            this.initialRetainCategories = JSON.parse(JSON.stringify(response.data[0].retainCategories));
            this.retainCategories.forEach(category => {
                if (category.selectedItem) {
                    category.selectedItem = category.items.find(item => item.id === category.selectedItem.id);
                }
            });
        });
    }

    getCategoryDisplayName(categoryName: string): string {
        return this.categoryDisplayNames[categoryName] || categoryName;
    }

    onCheckboxChange(category: any) {
        if (!category.isChecked) {
            category.selectedItem = null;
        }
    }

    updateNewData(category) {
        this.newData = category;
    }

    onRemoveAll() {
        this.retainModifiersPayload.isRemovedAll = true;
        this.retainCategories.forEach(category => {
            category.isChecked = false;
            category.selectedItem = null;
            this.retainModifiersPayload[category.name] = null;
        });
        this.dialogRef.close(this.retainModifiersPayload);
    }

    onRetainCurrentSelection() {
        this.retainCategories.forEach(category => {
            if (category.selectedItem) {
                this.retainModifiersPayload[category.name] = {
                    id: category.selectedItem.id,
                    name: category.selectedItem.name
                };
            } else {
                this.retainModifiersPayload[category.name] = null;
            }
        });
        this.dialogRef.close(this.retainModifiersPayload);
    }

    onRetainOldSelection() {
        this.retainModifiersPayload.isRetainOldSelection = true;
        this.initialRetainCategories.forEach(category => {
            if (category.selectedItem) {
                this.retainModifiersPayload[category.name] = {
                    id: category.selectedItem.id,
                    name: category.selectedItem.name
                };
            } else {
                this.retainModifiersPayload[category.name] = null;
            }
        });
        this.dialogRef.close(this.retainModifiersPayload);
    }

    onClose() {
        this.dialogRef.close();
    }

}
